import { Card } from '@/components/ui/card';
import { CheckCircle2, XCircle, AlertCircle } from 'lucide-react';

interface StatusOverviewProps {
  stats: {
    total: number;
    healthy: number;
    degraded: number;
    down: number;
    unknown: number;
  };
}

export const StatusOverview = ({ stats }: StatusOverviewProps) => {
  const { total, healthy, degraded, down } = stats;
  const uptime = total > 0 ? ((healthy / total) * 100).toFixed(1) : '0.0';

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      <Card className="p-6 bg-gradient-to-br from-card to-card/50">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-muted-foreground mb-1">System Uptime</p>
            <p className="text-3xl font-bold text-primary">{uptime}%</p>
          </div>
          <div className="p-3 rounded-lg bg-primary/10">
            <CheckCircle2 className="h-6 w-6 text-primary" />
          </div>
        </div>
      </Card>

      <Card className="p-6 bg-gradient-to-br from-card to-card/50">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-muted-foreground mb-1">Healthy</p>
            <p className="text-3xl font-bold text-success">{healthy}</p>
          </div>
          <div className="p-3 rounded-lg bg-success/10">
            <CheckCircle2 className="h-6 w-6 text-success" />
          </div>
        </div>
      </Card>

      <Card className="p-6 bg-gradient-to-br from-card to-card/50">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-muted-foreground mb-1">Degraded</p>
            <p className="text-3xl font-bold text-warning">{degraded}</p>
          </div>
          <div className="p-3 rounded-lg bg-warning/10">
            <AlertCircle className="h-6 w-6 text-warning" />
          </div>
        </div>
      </Card>

      <Card className="p-6 bg-gradient-to-br from-card to-card/50">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-muted-foreground mb-1">Down</p>
            <p className="text-3xl font-bold text-destructive">{down}</p>
          </div>
          <div className="p-3 rounded-lg bg-destructive/10">
            <XCircle className="h-6 w-6 text-destructive" />
          </div>
        </div>
      </Card>
    </div>
  );
};